<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Lista de albaranes de los proveedores</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    :to="{ path: $route.meta.guardar }"
                    :loading="isloading"
                    :disabled="isloading"
                    color="success"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text">mdi-plus</v-icon>
                </v-btn>
            </template>
            <span>Nuevo albarán</span>
        </v-tooltip>
        <v-row>
            <v-col cols="12" md="8">
                <!-- <v-text-field
                    prepend-icon="mdi-account-search"
                    v-model="search"
                    label="Buscar"
                ></v-text-field> -->

                <FilterComponent :headers="filter_headers" v-model="filters" />
            </v-col>
        </v-row>
        <v-data-table
            dense
            @click:row="
                (item) => {
                    OpenOrdenInNextWindow(item);
                }
            "
            :item-class="getRowClass"
            :headers="headers"
            :items="albaranes"
            item-key="id"
            class="elevation-1"
            :server-items-length="total_albaranes"
            :options.sync="options"
            @update:options="onOptionsUpdate"
        >
            <template v-slot:item.fecha="{ item }">
                <span>{{ item.fecha | format_date }}</span>
            </template>
            <template v-slot:item.importe="{ item }">
                {{ formatPrice(item.importe) }}€
            </template>
            <template v-slot:item.facturado="{ item }">
                <v-icon
                    color="success"
                    v-if="item.factura_entrante_linea != null"
                    >mdi-check-circle</v-icon
                >
                <v-icon color="error" v-else>mdi-cancel</v-icon>
            </template>

            <template v-slot:item.action="{ item }">
                <a @click.stop="openModal(item)">
                    <v-icon
                        small
                        class="mr-2"
                        color="red"
                        style="pointer-events: none; font-size: 25px"
                        title="BORRAR"
                        >mdi-trash-can</v-icon
                    >
                </a>
                <!--a @click.stop="openFacturaDialog(item)">
                    <v-icon
                        small
                        class="mr-2"
                        style="pointer-events: none; font-size: 25px"
                        title="CREAR FACTURA"
                        >mdi-file</v-icon
                    >
                </!--a-->
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteAlbaran()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <ConfimDialog
            v-model="confirm_factura"
            title="Confirmar factura"
            message="Confirmar creación de factura"
            @confirm="crearFactura"
        ></ConfimDialog>
        <ConfimDialog
            v-model="redirect_factura"
            title="Ir a factura"
            message="¿Desea ir a la factura creada?"
            @confirm="
                $router.push(`/guardar-factura-entrante?id=${factura_id}`)
            "
        ></ConfimDialog>
    </v-card>
</template>
<script>
import { debounce } from "../../../helpers";
import ConfimDialog from "./ConfimDialog.vue";
import FilterComponent from "../../../components/general/FilterComponent.vue";
import { formatPrice } from "../../../helpers";

export default {
    components: {
        ConfimDialog,
        FilterComponent,
    },
    data() {
        return {
            factura_id: null,
            redirect_factura: false,
            confirm_factura: false,
            selectedItem: null,
            cantidad: 15,
            page: 1,
            search: "",
            headers: [
                { text: "N° Albarán", value: "nro", sortable: false },
                {
                    text: "Nombre proveedor",
                    value: "proveedor.nombre",
                    sortable: false,
                },
                { text: "Fecha", value: "fecha", sortable: false },
                { text: "Importe", value: "importe", sortable: false },
                { text: "Facturado", value: "facturado" },
                // { text: "Población", value: "ciudad" },
                // { text: "Provincia", value: "provincia" },
                // { text: "Teléfono", value: "telefono" },
                // { text: "email", value: "email" },
                // { text: "Pdf", value: "pdf" },

                { text: "Acciones", value: "action", sortable: false },
            ],
            albaranes: [],
            selectedItem: 0,
            dialog: false,
            total_albaranes: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
                sortDesc: [],
            },
            filter_headers: [
                {
                    title: "Estado de facturación",
                    type: "select",
                    active: false,
                    model: "estado",
                    items: [
                        { id: 0, nombre: "Todos" },
                        { id: 1, nombre: "Facturado" },
                        { id: 2, nombre: "No facturado" },
                    ],
                    item_text: "nombre",
                    item_value: "id",
                },
            ],
            filters: {},
        };
    },
    created() {
        // this.getAlbaranes();
    },
    watch: {
        "$route.meta.especial"(val) {
            this.getAlbaranes();
        },
        search: debounce(function (val) {
            this.getAlbaranes();
        }, 500),
        filters: {
            deep: true,
            handler: function (val) {
                this.getAlbaranes();
            },
        },
    },
    methods: {
        OpenOrdenInNextWindow(item) {
            window.open(`#${this.$route.meta.guardar}?id=${item.id}`, "_blank");
        },
        getAlbaranes() {
            axios
                .get(`api/get-albaranes`, {
                    params: {
                        page: this.options.page,
                        amount: this.options.itemsPerPage,
                        especial: this.$route.meta.especial,
                        estado: this.filters.estado.value,
                        search: this.filters.search,
                    },
                })
                .then(
                    (res) => {
                        this.albaranes = res.data.success.data;
                        this.total_albaranes = res.data.success.total;
                    },
                    (err) => {
                        this.$custom_error(err.data.error);
                    }
                );
        },
        onOptionsUpdate(newOptions) {
            this.options = newOptions;
            this.getAlbaranes();
        },
        openModal(item) {
            this.selectedItem = this.albaranes.indexOf(item);
            this.dialog = true;
        },
        deleteAlbaran() {
            axios
                .delete(
                    `api/delete-albaran/${this.albaranes[this.selectedItem].id}`
                )
                .then(
                    (res) => {
                        this.$toast.sucs(res.data.success);
                        this.dialog = false;
                        this.getAlbaranes();
                    },
                    (err) => {
                        this.$custom_error(err.data.error);
                    }
                );
        },
        openFacturaDialog(item) {
            this.selectedItem = item;
            this.confirm_factura = true;
        },
        crearFactura() {
            axios
                .post("api/create-factura-entrante", this.selectedItem)
                .then((res) => {
                    this.$toast.sucs("Factura registrada con éxito");
                    this.confirm_factura = false;
                    this.factura_id = res.data.data.id;
                    this.redirect_factura = true;
                })
                .catch((error) => {
                    //console.log(error.response.status);
                    if (error.response.code == 400) {
                        this.$custom_error(error.response.data.error);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },

        formatPrice,

        // Metodo auxiliar
        getRowClass(item) {
            return "pointer";
        },

        // En desuso
        /*ChangeSize(event) {
            this.cantidad = event;
            this.getAlbaranes();
        },
        ChangePage(event) {
            this.page = event.page;
            this.getAlbaranes();
        },*/
    },
    computed: {
        isloading: function () {
            // return this.$store.getters.getloading
        },
    },
};
</script>
